import styled from 'styled-components'

import Box from '../../layout/Box/Box'
import Button from '../Button/Button'

export const ScrollableBox = styled(Box)`
  max-height: 275px;
  overflow: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 16px;
  margin: auto;
  width: max-content;
`

export const TriggerButton = styled(Button)`
  width: 40px;
`
